// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AuctionPaddle } from './auction-paddle';
import { AuctionPurchase } from './auction-purchase';
import { Person } from './person';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AuctionPaddleUser extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get displayName() {
    return `Paddle ${this.auctionPaddle.paddleNumber} --- ${this.name}`;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  address?: string;
  auctionPaddleId!: number;
  city?: string;
  closed?: Date;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  email?: string;
  name?: string;
  personId?: number;
  phone?: string;
  state?: string;
  zip?: string;
  auctionPaddle!: AuctionPaddle;
  auctionPurchases!: AuctionPurchase[];
  person!: Person;
}

